import React,{ useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import { Add } from "@material-ui/icons";
import Field from "../../../common/components/Field";
import {
  Grid,
  Button,
  Card,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { Formik } from "formik";

import styles from "./styles";

const renderScreens = (formik, dataScreens, count, arr) => {
    return (
      <Field
        inputLabel="Telas"
        options
        dataOptions={dataScreens}
        name={`screens[${count}]`}
        formik={formik}
      />
    );
  };

const CreateUser = ({
  classes,
  data,
  dataSub,
  onRequestSend,
  optionsGroup,
  reportsData,
  isLoadingOptions,
  isLoading,
}) => {
  const dataDepartments = [...data, ...dataSub];
  const dataGroups = [...optionsGroup];
  const [count, setCount] = useState(0);
  const [arr, setArr] = useState([]);
  const dataScreens = [...reportsData];

  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <div>
          <Card
            style={{
              margin: "auto",
              padding: 10,
              display: "flex",
              maxWidth: 230,
              background: "#fff",
              flexDirection: "column",
            }}
          >
            <Grid container xs={12} sm={6}>
              <Grid item>
                <Field formik label="Nome" name="name" formik={formik} />
                <Field
                  formik
                  label="Sobrenome"
                  name="last_name"
                  formik={formik}
                />
                <Field formik label="CPF" name="cpf" formik={formik} />
                <Field formik label="E-mail" name="email" formik={formik} />
                <Field formik label="Telefone" name="phone" formik={formik} />
                <Field
                  inputLabel="Grupo"
                  options
                  dataOptions={dataGroups}
                  name="group"
                  formik={formik}
                />
                <Field
                  inputLabel="Setor"
                  options
                  dataOptions={dataDepartments}
                  name="department"
                  formik={formik}
                />
                <Field
                 inputLabel="Telas"
                  options
                  dataOptions={dataScreens}
                  name="screens[0]"
                  formik={formik}
                />
               {count > 0
                 ? arr.map((item) =>
                      renderScreens(formik, dataScreens, count)
                    )
                 : null}
              </Grid>
            </Grid>
            <div style={{ flex: 1, justifyItems: "flex-end" }}>
              <Button
                onClick={() => {
                  setCount(count + 1);
                  setArr([...arr, count + 1]);
               }}
                size="small"
                className={classes.buttonAdd}
                aria-label="add"
              >
                <Add />
              </Button>
            </div>
            <Button
              onClick={() => onRequestSend(formik.values)}
              className={classes.button}
            >
              {isLoading ? (
                <CircularProgress style={{ color: "#fff" }} size={25} />
              ) : (
                "CADASTRAR"
              )}
            </Button>
          </Card>
        </div>
      )}
    </Formik>
  );
};

export default withStyles(styles)(CreateUser);
